import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.auth.PasswordResetModule', {
    emailRequired: 'The email address is required.',
    emailInvalid: 'The email address is not valid.',
    emailPlaceholder: 'Enter email...',
    titleSuccessText: 'Check your inbox',
    successComment: 'We have just sent a password reset link email to {email}',
    titleText: 'Reset your password',
    resetButtonText: 'Send me a password reset email',
    loginNowButtonText: 'Log in now',
});
